import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { UserControllerGetConfigResponse } from '../responses/user-controller-get-config.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'legacy',
    operationId: 'user-controller-getConfig',
    operation: '{"operationId":"user-controller-getConfig","responses":{"200":{"content":{"application/json":{"schema":{"type":"object","additionalProperties":{"type":"string"}}}}}},"method":"get","path":"/user-controller/config"}'
  })
export class UserControllerGetConfigRemoteMethod extends OpenApiRemoteMethod<UserControllerGetConfigResponse, void, void> {
  public override call(): Promise<UserControllerGetConfigResponse> {
    return super.call();
  }
}
